import { TPredicateOperator } from '@src/models/api';
import { TFilterType } from '../models';

export const DEFAULT_FILTER_OPERATORS_MAP: Record<Exclude<TFilterType, 'dateRange'>, TPredicateOperator> = {
  boolean: 'EQUALS',
  options: 'IN',
  string: 'EQUALS',
};
